// ! This file was auto-generated from the esign OpenAPI schema. Do not override this file.
export const Tags = {
    Authorization: "Authorization",
    Healthchecks: "Healthchecks",
    Integrations: "Integrations",
    Internal_Integrations: "Internal Integrations",
    Internal_Packages: "Internal Packages",
    Packages: "Packages",
    Tokens: "Tokens",
    Vendors: "Vendors",
    Webhook: "Webhook"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
